import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setCadastralFieldRequired } from '../../../actions/rosreestrData/setCadastralFieldRequired';
import { setRequiredError } from '../../../actions/rosreestrData/setRequiredError';
import { ECadastralFieldsNames } from '../../../types/reducers/rosreestrData';
import { trackNoCadastralNumberButtonClick, trackNoCadastralNumberReasonSubmit } from '../tracking';

interface IParams {
  setShowNoCadastralNumberButton(value: boolean): void;
}

type TUseNoCadastralNumberReasonModal = [boolean, () => void, (reason: string) => void];

/** Управление модалкой "Не указывать кадастровый номер участка" */
export const useNoCadastralNumberReasonModal = ({
  setShowNoCadastralNumberButton,
}: IParams): TUseNoCadastralNumberReasonModal => {
  const dispatch = useDispatch();
  const [reasonModalOpened, setReasonModalOpened] = useState(false);

  const handleReasonModalOpen = useCallback(() => setReasonModalOpened(true), []);

  const handleReasonModalClose = useCallback(
    (value: string) => {
      setReasonModalOpened(false);
      setShowNoCadastralNumberButton(false);
      trackNoCadastralNumberReasonSubmit(value);
    },
    [setShowNoCadastralNumberButton],
  );

  useEffect(() => {
    /* istanbul ignore else */ if (reasonModalOpened) {
      const params = { key: ECadastralFieldsNames.CadastralNumber, value: false };

      [setCadastralFieldRequired, setRequiredError].forEach(action => {
        dispatch(action(params));
      });

      trackNoCadastralNumberButtonClick();
    }
  }, [dispatch, reasonModalOpened]);

  return [reasonModalOpened, handleReasonModalOpen, handleReasonModalClose];
};
